import styled, { css } from 'styled-components';
import { rem } from 'polished';
var AssetObject = styled.object.withConfig({
  displayName: "AssetObject",
  componentId: "rvykgd-0"
})(["height:auto;line-height:1;pointer-events:none;width:auto;", " ", " ", " ", ""], function (_ref) {
  var containerHeight = _ref.containerHeight;
  return containerHeight && css(["height:100%;"]);
}, function (_ref2) {
  var containerHeight = _ref2.containerHeight;
  return containerHeight && css(["height:100%;"]);
}, function (_ref3) {
  var assetHeight = _ref3.assetHeight,
      assetWidth = _ref3.assetWidth;
  return assetHeight && !assetWidth && css(["height:", ";"], rem(assetHeight));
}, function (_ref4) {
  var assetHeight = _ref4.assetHeight,
      assetWidth = _ref4.assetWidth;
  return !assetHeight && assetWidth && css(["width:", ";"], rem(assetWidth));
});
export default AssetObject;